export default __webpack_public_path__ + "static/media/1794_detail_comp.a8b3ae13.jpg";